import axios from 'axios'
import API from '@/API.js'

const apiClient = axios.create({
  baseURL: `${API}/sistema/pasarelas-pago`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: localStorage.getItem('argusblack.token')
  }
})

// Actualización del token de autorización
document.addEventListener('actualizar:token', function(e) {
  apiClient.defaults.headers['Authorization'] = e.detail
})

// Eliminación del token de autorización
document.addEventListener('eliminar:token', function() {
  apiClient.defaults.headers['Authorization'] = null
})

export default {
  pasarelaJSON(idPasarela, params) {
    params = params || {}
    return apiClient.get(`${idPasarela}.json`, { params: params })
  },

  pasarelasJSON() {
    return apiClient.get(`${API}/sistema/pasarelas-pago.json`)
  },

  configuracionJSON(idPasarela) {
    return apiClient.get(`${idPasarela}/configuracion.json`)
  },

  guardarConfiguracion(idPasarela, configuracion) {
    return apiClient.post(`${idPasarela}/configuracion`, configuracion)
  }
}